import { useRecoilState } from 'recoil';

import { modalState } from 'store/state';

const useModal = () => {
    const [modal, setModal] = useRecoilState(modalState);

    const onOpen = (type, options = {}) => {
        setModal({ type, isOpen: true, options });
    };

    const onClose = () => {
        setModal({ isOpen: false });
    };

    const onToggle = (type, options = {}) => {
        setModal({ type: modal.isOpen ? type : null, isOpen: !modal.isOpen, options });
    };

    return {
        modal,
        onOpen,
        onClose,
        onToggle,
    };
};

export default useModal;
